export const createPrizePayload = ({ prize, index, params = {} }) => {
  return {
    item_id: prize.codigoDePremio,
    item_name: prize.nombreDelBono,
    item_category: prize.category || "",
    price: prize.numeroDePuntos || 0,
    quantity: prize.premioActivo ? 1 : 0,
    coupon: null,
    discount: 0,
    index,
    affiliation: "Nosotras Online",
    item_brand: "Nosotras",
    item_variant: "único",
    currency: "COP",
    ...params,
  }
}

export const createListPrizePayload = (prizes, params = {}) => {
  return prizes.map((prize, index) => {
    return createPrizePayload({ prize, index, params })
  })
}

export const createProductPayload = ({ product, index, params = {} }) => {
  return {
    item_id: product.codigoDeProducto,
    item_name: product.titulo,
    coupon: null,
    discount: 0,
    index,
    affiliation: "Nosotras Online",
    item_brand: "Nosotras",
    item_category: product.referenciaSubcategoria?.slug || "",
    item_variant: "único",
    price: 0,
    currency: "COP",
    quantity: 0,
    ...params,
  }
}

export const createListProductPayload = (products, params = {}) => {
  return products.map((product, index) => {
    return createProductPayload({ product, index, params })
  })
}
